"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleItemActions = void 0;
var _react = _interopRequireDefault(require("react"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var props = {
  scale: "s",
  style: {
    display: "flex"
  }
};
var singleItemActions = [{
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "star"
  }, props)),
  label: "Add to Favorites",
  onClick: function onClick(itemId) {
    return console.log(itemId);
  },
  id: "favorites"
}, {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "feature-details"
  }, props)),
  label: "View item details",
  onClick: function onClick(itemId) {
    return console.log(itemId);
  },
  id: "details"
}, {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "launch",
    scale: "s"
  }, props)),
  label: "Open in Map Viewer",
  onClick: function onClick(itemId) {
    return console.log(itemId);
  },
  id: "launchinmap"
}, {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "map",
    scale: "s"
  }, props)),
  label: "Add to new map",
  onClick: function onClick(itemId) {
    return console.log(itemId);
  },
  id: "addtomap"
}, {
  icon: /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteIcon, _extends({
    icon: "launch",
    scale: "s"
  }, props)),
  label: "Open in Scene Viewer",
  onClick: function onClick(itemId) {
    return console.log(itemId);
  },
  id: "launchinscene"
}];
exports.singleItemActions = singleItemActions;